export const Logger = (() => {
    const debug = true;
    return {
        log() {
            if (debug === true) {
                const args = Array.prototype.slice.call(arguments);
                console.log(...args);
            }
        },
        warn() {
            if (debug === true) {
                const args = Array.prototype.slice.call(arguments);
                console.warn(...args);
            }
        },
        error() {
            const args = Array.prototype.slice.call(arguments);
            console.error(...args);
        }
    };
})();